.setting-row {
  justify-content: space-between;
}

.dropdown-container {
  min-width: 240px;
}
